// Import React Library
import React from 'react';

// Import Icons
import InfoIcon from '@mui/icons-material/Info';

// Import Icons
import ApartmentIcon from '@mui/icons-material/Apartment';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import { TbEyeSpark } from "react-icons/tb";

// Import React Reveal
import { Fade } from "react-awesome-reveal";

// About Us component
const AboutUs = () => {
    return (
        <div className='about-us'>
            <div className='about-us-container about-us-image'>
                <Fade direction='up' triggerOnce={true} className='advantages-col'> 
                    <TbEyeSpark className='about-us-icon'/>
                    <p className='text-gray-800'>
                        Hoy, miramos hacia el futuro manteniendo intacto el espíritu original: ser el aliado más
                        confiable en materiales de construcción, acompañándote en tus proyectos con productos de
                        calidad garantizada y la asistencia que necesitas.
                    </p>
                </Fade>
            </div>

            <div className='about-us-container about-us-data'>
                <h2 className='text-gray-800'>Sobre Nosotros <InfoIcon  className='about-icon'/></h2>
                <span></span>

                < ApartmentIcon  className='about-us-icon text-gray-800'/>
                <p className='text-gray-800'>
                    Desde 2015 iniciamos como una empresa familiar, especializada en la importación directa de
                    <strong> isopaneles</strong>, ofreciendo la mayor variedad de materiales y medidas del mercado. Nuestra visión
                    es simple: proveer soluciones de construcción innovadoras y eficientes con precios
                    competitivos, respaldadas por una atención al cliente excepcional.
                </p>

                <FamilyRestroomIcon className='about-us-icon text-gray-800'/>
                <p className='text-gray-800'>
                    Para ofrecer una solución integral, hemos ampliado estratégicamente nuestro portafolio,
                    incorporando categorías esenciales como revestimientos, pisos, aberturas, herramientas e
                    insumos para la colocación.
                </p>
            </div>
        </div>
    );
};

// Export About Us component
export default AboutUs;